module.exports = __webpack_public_path__ + "static/media/yoursoftwaresupplier.d473cdb3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/yoursoftwaresupplier.webp
// module id = 274
// module chunks = 0